import { AppState } from '../../../redux/reducers';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ErrorType } from '../../../models/HttpError';

//stores
import * as ContractsStore from '../../../redux/middleware/ContractMiddleware';
import * as ProtocolsStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as PractitionersStore from '../../../redux/middleware/PractitionerMiddleware';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { ContractPractitionerAssociation } from '../../../models/Entities/Contracts/ContractPractitionerAssociation';
import { ContractProtocolAssociation } from '../../../models/Entities/Contracts/ContractProtocolAssociation';

//#region Props

interface IProps {
  ContractId: number;
}

interface ConnectedProps {
  isLoading: boolean;
  isLoadingSuccessfully: boolean;
  failOnLoading: boolean;
  error: ErrorType | undefined;
  Contract: Contract | undefined;
  Practitioner: Practitioner | undefined;
  Protocol: Protocol | undefined;
  ProtocolAssociation: ContractProtocolAssociation | undefined;
  PractitionerAssociation: ContractPractitionerAssociation | undefined;

  // estado de las operaciones de asociación
  isAssociatingProtocol: boolean;
  isDisassociatingProtocol: boolean;
  isAssociatingPractitioner: boolean;
  isDisassociatingPractitioner: boolean;
  associationError: ErrorType | undefined;
  failOnAssociation: boolean;
}

interface MedicalServicesDispatchProps {
  GetAllContracts: typeof ContractsStore.actionCreators.GetAllContracts;
  GetContractById: typeof ContractsStore.actionCreators.GetContractById;
  GetAllPractitioners: typeof PractitionersStore.actionCreators.GetAllPractitioners;
  GetAllMedicalProtocols: typeof ProtocolsStore.actionCreators.GetAllMedicalProtocols;
  DisassociateContractFromPractitioner: typeof ContractsStore.actionCreators.DisassociateContractFromPractitioner;
  DisassociateContractFromProtocol: typeof ContractsStore.actionCreators.DisassociateContractFromProtocol;
  AssociateContractToPractitioner: typeof ContractsStore.actionCreators.AssociateContractToPractitioner;
  AssociateContractToProtocol: typeof ContractsStore.actionCreators.AssociateContractToProtocol;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
  const CurrentContract: Contract | undefined = state.Contract?.list?.find(
    (contract: Contract) => contract?.id === ownProps.ContractId
  );

  // Las colecciones pueden no venir en el detalle del contrato: se accede de forma defensiva.
  const ProtocolAssociation: ContractProtocolAssociation | undefined = CurrentContract?.protocol?.[0];
  const PractitionerAssociation: ContractPractitionerAssociation | undefined =
    CurrentContract?.practitioners?.[0];

  return {
    isLoading: state.Contract?.isLoadingAll,
    isLoadingSuccessfully: state.Contract?.successLoadingAll,
    failOnLoading: state.Contract?.failOnLoadingAll,
    failOnDeleting: state.Contract?.failOnDeletingOne,
    error: state.Contract?.error,
    Contract: CurrentContract,
    ProtocolAssociation: ProtocolAssociation,
    PractitionerAssociation: PractitionerAssociation,
    Practitioner: PractitionerAssociation?.practitionerId
      ? state.Practitioners?.list?.find(
          (practitioner: Practitioner) =>
            practitioner.userId === PractitionerAssociation.practitionerId
        )
      : undefined,
    Protocol: ProtocolAssociation?.protocolId
      ? state.MedicalProtocols?.list?.find(
          (protocol: Protocol) => protocol.id === ProtocolAssociation.protocolId
        )
      : undefined,

    // estado de las operaciones de asociación
    isAssociatingProtocol: state.Contract?.isAssociatingProtocol === true,
    isDisassociatingProtocol: state.Contract?.isDisassociatingProtocol === true,
    isAssociatingPractitioner: state.Contract?.isAssociatingPractitioner === true,
    isDisassociatingPractitioner: state.Contract?.isDisassociatingPractitioner === true,
    associationError: state.Contract?.associationError,
    failOnAssociation:
      state.Contract?.FailAssociatingProtocol === true ||
      state.Contract?.FailDisassociatingProtocol === true ||
      state.Contract?.FailAssociatingPractitioner === true ||
      state.Contract?.FailDisassociatingPractitioner === true
  };
};

export const mapDispatchToProps = {
  ...ContractsStore.actionCreators,
  ...ProtocolsStore.actionCreators,
  ...PractitionersStore.actionCreators
};

//#endregion Props
